export const CHANGE_CHECKLIST_DATE_TYPES = ['month'];
